// #region Imports

import React from 'react';

// Material-UI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

// Auth0 user hooks 
import { useAuth0 } from '@auth0/auth0-react';

// Responsive hooks
import { useResponsive } from '../hooks/UseResponsive';

// #endregion

const Home: React.FC = () => {

  // Auth0 hooks
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const { isMobile } = useResponsive();

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      flexGrow: 1,
      margin: theme.spacing(5, 0, 0, 0)
    },
    browsers: {
      margin: theme.spacing(6, 0, 0, 0)
    },
    loginButton: {
      margin: theme.spacing(4, 0, 0, 0)
    },
    vpn: {
      margin: theme.spacing(3, 0, 0, 0)
    },
  };

  // #endregion

  // #region Event Handlers

  /*
* Event handler for Login element
*/
  const handleLogin = (): void => {
    loginWithRedirect();
  }

  // #endregion

  return (
    <Box sx={styles.root}>
      <Grid container justifyContent="center">
        <img src="images/msc_logo_150x150.jpg" width="150" height="150" alt="Montclair Ski Club" />
      </Grid>
      <Grid container justifyContent="center">
        <Typography gutterBottom variant="h5">Montclair Ski Club</Typography>
      </Grid>
      <Grid container justifyContent="center" >
        <Typography variant="body1" color="textSecondary">Since 1947</Typography>
      </Grid>
      {!isAuthenticated &&
        <Grid container justifyContent="center">
          <Grid size={2}>
            <Button variant="contained" color="primary" fullWidth sx={styles.loginButton} onClick={handleLogin}>Login</Button>
          </Grid>
        </Grid>
      }
      <Grid container justifyContent="center" sx={styles.browsers}>
        <Grid  >
          <Typography variant="button">Supported Browsers</Typography>
        </Grid>
      </Grid>
      {!isMobile &&
        <>
          <Grid container justifyContent="center">
            <Typography variant="caption">Desktop: Chrome, Edge, FireFox &amp; Safari</Typography>
          </Grid>
          <Grid container justifyContent="center">
            <Typography variant="caption">Mobile: Chrome, &amp; Safari</Typography>
          </Grid>
        </>
      }
      {isMobile &&
        <Grid container justifyContent="center">
          <Typography variant="caption">Mobile: Chrome, &amp; Safari</Typography>
        </Grid>
      }
      <Grid container justifyContent="center" sx={styles.vpn}>
        <Typography variant="caption">Use with a VPN is not supported</Typography>
      </Grid>
    </Box>
  );
}

export default Home;

